module.exports = __webpack_public_path__ + "img/26.143b4e9e.jpg";